import UploadSmallPhoto from "./UploadSmallPhoto";

export default UploadSmallPhoto;
